import React from 'react';

import { ITransactionsCard } from '@pages/statistics/transactions/interfaces';
import Card from '@pages/statistics/transactions/Cards/Card';

interface ITransactionsCards {
    cards: ITransactionsCard[];
    isFetching: boolean;
}

const Cards: React.FC<ITransactionsCards> = ({ cards, isFetching }) => {
    return (
        <div className="px-2 pb-4 mb-4 -mx-2 overflow-scroll hide-scrollbar">
            <div className="flex w-full xs:justify-between">
                {cards.map(card =>
                    isFetching ? (
                        <div
                            key={card.label}
                            className="w-full mr-8 hack-min-w-128px last:mr-0 rounded-2 h-[118px] lg:h-[134px] animate-[placeholed-move]"
                        />
                    ) : (
                        <Card key={card.label} card={card} />
                    ),
                )}
            </div>
        </div>
    );
};

export default Cards;
